import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f082e3f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-subtask-view__taskid" }
const _hoisted_2 = { class: "task-subtask-view__name" }
const _hoisted_3 = { class: "task-subtask-view__performers" }
const _hoisted_4 = { class: "task-subtask-view__hint" }
const _hoisted_5 = { class: "task-subtask-view__performers-hidden-count" }
const _hoisted_6 = { class: "task-subtask-view__list" }
const _hoisted_7 = { class: "task-subtask-view__hint" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "task-subtask-view__absence-data"
}
const _hoisted_10 = { style: {"margin-left":"auto"} }
const _hoisted_11 = { class: "task-subtask-view__confirm-popover" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-subtask-view__confirm-popover-message" }, " Открепить подзадачу? ", -1))
const _hoisted_13 = { class: "task-subtask-view__confirm-popover-buttons" }
const _hoisted_14 = { class: "task-subtask-view__menu-item" }
const _hoisted_15 = { class: "task-subtask-view__menu-item" }
const _hoisted_16 = { class: "task-subtask-view__menu-item" }

import { computed, inject, PropType, Ref, ref, watch } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmPopover,
  PopoverPositionEnum,
  PopoverColorEnum,
  TirPmContextMenu,
  TirPmContextMenuMouseButtonEnum,
  TirPmContextMenuButton,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmTooltipElement,
} from 'tir-components';
import {
  ArrowsPointingOutIcon,
  CurtainIcon,
  ListBulletIcon,
  MapIcon,
  ShareIcon,
  TrashIcon,
} from 'tir-style-system/icons/outline';
import { FlagIcon } from 'tir-style-system/icons/solid';
import { QueueRelationModel, SubtaskModel, UserModel } from '../../models';
import { RouterLink, useRouter } from 'vue-router';
import TaskDrawer from '../task-drawer/task-drawer.vue';
import { TaskDrawerSettingsModel } from '../task-drawer';
import { TaskParameter, TaskParameterModel, TaskParameterTypeEnum } from '@/components';
import { copyToClipboard } from '../../utils';
import { TaskModel } from '../task-drawer/models';

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-subtask-view',
  props: {
  /**id проекта */
  projectId: { type: Number, required: true },
  /**id очереди */
  queueId: { type: String },
  /**Подзадача */
  subtask: {
    type: Object as PropType<SubtaskModel>,
    required: true,
  },
  /**Кол-во видимых исполнителей */
  countVisiblePerformers: {
    type: Number,
    default: 4,
  },
  /**Загрузка при откреплении задачи */
  isLoadingUnattachButton: {
    type: Boolean,
    default: false,
  },

  editing: { type: Boolean, default: true },
},
  emits: ["onClickDelete", "updatedSubtask"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const router = useRouter();

/**Параметры */

/**События */


const $confirmUnattachPopover = ref<InstanceType<typeof TirPmPopover>>();
/**Ссылка на компонент контекстного меню */
const $contextMenu = ref<InstanceType<typeof TirPmContextMenu>>();
/**Ссылка на компонент шторки задачи */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();
/**Ссылка на DOM */
const $subtask = ref<HTMLElement>();
/**Отображать схему подзадач */
const showSchema = ref(false);

const performerVisible = computed(() =>
  props.subtask.Performers.slice(0, props.countVisiblePerformers),
);
const hiddenCountPerformers = computed(
  () => props.subtask.Performers.length - performerVisible.value.length,
);

const statusParam = computed(
  () =>
    props.subtask.Status &&
    new TaskParameterModel({
      Id: props.subtask.Status.Id,
      Name: props.subtask.Status.Name,
      Color: props.subtask.Status.Color,
    }),
);

const computedName = (user: UserModel) => {
  return user.FirstName?.[0]?.toUpperCase() + user.LastName?.[0]?.toUpperCase();
};

const openTaskInDrawer = (subtaskId: number) => {
  $contextMenu.value?.close();
  openDrawer(subtaskId);
};

/**Открыть задачу */
const openDrawer = (subtaskId: number) => {
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'edit',
      TaskId: subtaskId,
    }),
  );
};
/**Перейти в очередь */
const goToQueue = (queue: QueueRelationModel) => {
  return router.resolve({
    name: 'queue',
    params: {
      projectId: props.projectId,
      namespaceId: queue.Namespace.Id,
      queueId: queue.Id,
    },
  })?.href;
};
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};

/**Скопировать название и ссылку */
const copyNameAndLinkTask = async () => {
  if (!props.projectId || !props.queueId) return;

  const route = router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.projectId,
      queueId: props.queueId,
      taskId: props.subtask.Id,
    },
  });

  if (!route?.href) return;
  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = origin + route.href;
  const textContent = `${props.subtask.Id} ${props.subtask.Name}`;

  if (await copyToClipboard(`[${textContent}](${link})`)) {
    $contextMenu.value.close();
    addNotification('Название и ссылка тикета скопирована');
    console.log(10);
  }
};

/**Переход в задачу */
const computedRoute = computed(() => {
  return router.resolve({
    name: 'task-detail',
    params: {
      taskId: props.subtask.Id,
      projectId: props.projectId,
      namespaceId: props.subtask.Queues[0].Namespace.Id,
      queueId: props.queueId,
    },
  })?.href;
});
/**Открыть карту проекта */
const openSchema = computed(() => {
  return router.resolve({
    name: 'project-map',
    params: {
      taskId: props.subtask.Id,
      projectId: props.projectId,
    },
  });
});
__expose({
  subtaskItem: $subtask,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmContextMenu), {
      class: "context-menu",
      ref_key: "$contextMenu",
      ref: $contextMenu,
      "min-width": "20rem",
      maxHeight: "max-content",
      "trigger-buttons": [_unref(TirPmContextMenuMouseButtonEnum).Right]
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(RouterLink), {
          to: computedRoute.value,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmContextMenuButton), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(ArrowsPointingOutIcon), { class: "task-subtask-view__menu-icon" }),
                  _createTextVNode(" Открыть в новой вкладке ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(RouterLink), { to: openSchema.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmContextMenuButton), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_unref(MapIcon), { class: "task-subtask-view__menu-icon" }),
                  _createTextVNode(" Посмотреть карту проекта ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(TirPmContextMenuButton), { onClick: copyNameAndLinkTask }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(ShareIcon), { class: "task-subtask-view__menu-icon" }),
              _createTextVNode(" Скопировать название и ссылку ")
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(RouterLink), {
          ref_key: "$subtask",
          ref: $subtask,
          class: "task-subtask-view",
          to: computedRoute.value,
          onMousedown: [
            _cache[5] || (_cache[5] = _withModifiers(($event: any) => (openTaskInDrawer(__props.subtask.Id)), ["left"])),
            _cache[6] || (_cache[6] = _withModifiers(() => {}, ["middle","prevent"]))
          ]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "task-subtask-view__status",
              style: _normalizeStyle({ backgroundColor: __props.subtask.Status.Color })
            }, null, 4),
            _createElementVNode("div", _hoisted_1, _toDisplayString(__props.subtask.Id), 1),
            (statusParam.value)
              ? (_openBlock(), _createBlock(_unref(TaskParameter), {
                  key: 0,
                  type: _unref(TaskParameterTypeEnum).Status,
                  data: statusParam.value,
                  preview: "",
                  "hide-remove": ""
                }, null, 8, ["type", "data"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.subtask.Name), 1),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(performerVisible.value, (performer) => {
                return (_openBlock(), _createBlock(_unref(TirPmTooltipElement), { width: "max-content" }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(performer.LastName) + " " + _toDisplayString(performer.FirstName) + " " + _toDisplayString(performer.MiddleName), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_unref(TirPmIconView), {
                      class: "task-subtask-view__performer",
                      size: 24,
                      "image-load-url": performer.ImageUrl,
                      "color-code": performer.AvatarColor,
                      "is-rounded": "",
                      key: performer.Id
                    }, {
                      mainSlot: _withCtx(() => [
                        _createTextVNode(_toDisplayString(computedName(performer)), 1)
                      ]),
                      _: 2
                    }, 1032, ["image-load-url", "color-code"]))
                  ]),
                  _: 2
                }, 1024))
              }), 256)),
              (hiddenCountPerformers.value > 0)
                ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
                    key: 0,
                    class: "task-subtask-view__performer",
                    size: 24,
                    "is-rounded": ""
                  }, {
                    mainSlot: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, " +" + _toDisplayString(hiddenCountPerformers.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(TirPmTooltipElement), { class: "tir-pm-task-card_popover" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ListBulletIcon), {
                  class: "task-subtask-view__queue-icon",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                })
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.subtask.Queues, (queue, idx) => {
                    return (_openBlock(), _createBlock(_unref(RouterLink), {
                      textContent: _toDisplayString(queue.Name),
                      key: idx,
                      class: "task-subtask-view__list__item",
                      to: goToQueue(queue),
                      target: "_blank"
                    }, null, 8, ["textContent", "to"]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(TirPmTooltipElement), null, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (__props.subtask.Priority.Name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.subtask.Priority.Name), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, "-"))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(FlagIcon), {
                  class: "task-subtask-view__priority-icon",
                  style: _normalizeStyle({ color: __props.subtask.Priority.Color })
                }, null, 8, ["style"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"])),
                onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop","prevent"]))
              }, [
                _createVNode(_unref(TirPmPopover), {
                  ref_key: "$confirmUnattachPopover",
                  ref: $confirmUnattachPopover,
                  "custom-position": {
              right: '0rem',
              bottom: '0.25rem',
            }
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_unref(TirPmButton), {
                          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                          size: _unref(TirPmButtonSizeEnum).Small,
                          "is-loading": __props.isLoadingUnattachButton,
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('onClickDelete')), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Открепить ")
                          ]),
                          _: 1
                        }, 8, ["variant", "size", "is-loading"]),
                        _createVNode(_unref(TirPmButton), {
                          variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                          size: _unref(TirPmButtonSizeEnum).Small,
                          "is-disabled": __props.isLoadingUnattachButton,
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($confirmUnattachPopover.value?.close()), ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Отмена ")
                          ]),
                          _: 1
                        }, 8, ["variant", "size", "is-disabled"])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    (__props.editing)
                      ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                          key: 0,
                          variant: _unref(TirPmButtonVariantEnum).LinkState,
                          size: _unref(TirPmButtonSizeEnum).Small,
                          "is-loading": __props.isLoadingUnattachButton
                        }, {
                          leftSlot: _withCtx(() => [
                            _createVNode(_unref(TrashIcon))
                          ]),
                          _: 1
                        }, 8, ["variant", "size", "is-loading"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 512)
              ], 32)
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["trigger-buttons"]),
    _createVNode(TaskDrawer, {
      ref_key: "$taskDrawer",
      ref: $taskDrawer,
      onOnUpdateTask: _cache[7] || (_cache[7] = ($event: any) => (emit('updatedSubtask', __props.subtask.Id))),
      onRemoveSubtaskItem: _cache[8] || (_cache[8] = ($event: any) => (emit('onClickDelete')))
    }, null, 512)
  ], 64))
}
}

})